// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'amfe-flexible'

import "swiper/css/swiper.min.css"
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

import 'animate.css';
import '@/assets/iconfont/iconfont01/iconfont.css'

import '@/assets/css/swiper_custom.css'

Vue.component('Swiper', Swiper);
Vue.component('SwiperSlide', SwiperSlide);

import ScrollView from '@/plugins/ScrollView';
Vue.use(ScrollView);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js